// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import ExcelJS from 'exceljs';
export class FilesHelper {
    static getBlobTypeByFileName(filename) {
        var _a;
        if (filename == null) {
            return null;
        }
        const splits = filename.split('.');
        const extension = splits.length > 0 ? splits[splits.length - 1] : '';
        const blobType = (_a = this.BlobTypesByExtension[extension]) !== null && _a !== void 0 ? _a : this.BlobTypesByExtension.txt;
        return blobType;
    }
    static s2ab(s) {
        // need for export to Excel with SheetJS #93681
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) {
            view[i] = s.charCodeAt(i) & 0xff;
        }
        return buf;
    }
    // #endregion Private
    // #region Public
    static saveFile(filename, data, blob) {
        const file = blob !== null && blob !== void 0 ? blob : new Blob([data], { type: this.getBlobTypeByFileName(filename) });
        if (window.navigator.msSaveOrOpenBlob != null) {
            // IE10+
            window.navigator.msSaveOrOpenBlob(file, filename);
        }
        else {
            // Others
            const a = document.createElement('a');
            const url = URL.createObjectURL(file);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 0);
        }
    }
    static saveExcelFile(filename, tables) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const workbook = new ExcelJS.Workbook();
            workbook.creator = filename;
            workbook.created = new Date();
            for (const table of tables) {
                const tableData = (_a = table.Data) !== null && _a !== void 0 ? _a : [];
                const sheetName = isValidString(table.TableName) ? table.TableName.slice(0, 31) : ''; // can't set sheetNames longer than 31 symb
                const worksheet = workbook.addWorksheet(sheetName);
                worksheet.addRows(tableData);
            }
            const buffer = yield workbook.xlsx.writeBuffer();
            this.saveFile(filename + '.xlsx', null, new Blob([buffer], { type: 'application/octet-stream' }));
        });
    }
}
// #region Private
FilesHelper.BlobTypesByExtension = {
    // https://www.iana.org/assignments/media-types/media-types.xhtml#text
    txt: 'text/plain',
    html: 'text/html',
    json: 'application/json',
    csv: 'text/csv',
    log: 'text/plain'
};
